export function toStudyRevisionEvent(attribute) {
    return {
        name: attribute.name,
        description: attribute.description,
        createdBy: attribute.createdBy,
        attributeOperation: attribute.attributeOperation,
        created: attribute.created,
    };
}
//# sourceMappingURL=study-revision-event.js.map